import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getQuantityOptions',
  pure: true,
  standalone: false
})
export class GetQuantityOptionsPipe implements PipeTransform {
  transform(pu: any, getOptionalUpgradeQuantitiesFunction: Function): any[] {
    if (!pu || !getOptionalUpgradeQuantitiesFunction) {
      return [];
    }
    return getOptionalUpgradeQuantitiesFunction(pu);
  }
}